import axios from 'axios'
import { useMemo } from 'react'
import { $api, $file } from '..'
import sanitizedConfig from '../../Config'
import { setEmployeeUser, setOriginUrl } from '../../slices/AppSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks/redux'
import { getUserClientCompanies } from '../../services/MedicService'

function preparedQuery(obj: Record<string, any>, parentKey = ''): string {
  return Object.entries(obj)
    .flatMap(([key, value]) => {
      const newKey = parentKey ? `${parentKey}[${key}]` : key
      if (typeof value === 'object' && value !== null) {
        return Array.isArray(value)
          ? value.flatMap((item, index) => preparedQuery({ [index]: item }, `${newKey}`))
          : preparedQuery(value, newKey)
      }
      return `${newKey}=${encodeURIComponent(value)}`
    })
    .join('&')
}

export const useAxiosIntercceptors = () => {
  const { employeeUser } = useAppSelector(state => state.appReducer)
  const dispatch = useAppDispatch()
  const isAuth = localStorage.getItem('isAuth')

  $api.interceptors.request.use(
    async config => {
      const BASE_URL = sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL

      const urlArray = config.url?.split('/')
      config.baseURL = BASE_URL
      if (config.url === '/v1/web/auth/refresh') return config
      const reversedUrlArray = urlArray?.reverse()
      if (reversedUrlArray) {
        if (
          (urlArray?.length === 5 && reversedUrlArray[0] === 'base64') ||
          (reversedUrlArray[0] === 'buffer' && config.method === 'get')
        ) {
          config.baseURL = sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL
        }

        if (urlArray?.reverse()[0] === 'files' && config.method === 'get') {
          config.responseType = 'blob'
        }
      }

      let currentAccessToken = localStorage.getItem('accessToken')
      if (!!currentAccessToken) {
        config.headers.Authorization = `Bearer ${currentAccessToken}`
      }
      return config
    },
    error => {
      console.log('Ошибка!')
      console.log(error)
    }
  )

  $api.interceptors.response.use(
    config => {
      if (config.data?.access_token) {
        localStorage.setItem('accessToken', config.data.access_token)
      }
      if (config.data?.refresh_token) {
        localStorage.setItem('refreshToken', config.data.refresh_token)
      }
      return config
    },
    async error => {
      if (!error.response) {
        console.error('Нет ответа от сервера:', error)
        return Promise.reject(error)
      }

      const originalRequest = error.config
      if (error.response.status === 401 && originalRequest && !originalRequest._isRetry) {
        originalRequest._isRetry = true
        try {
          const currentToken = localStorage.getItem('accessToken')
          if (!currentToken) {
            localStorage.removeItem('isAuth')
            window.location.reload() //window.location.href = '/login'
            return Promise.reject(error)
          }

          const response = await axios.request({
            method: 'post',
            url: sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL + '/v1/web/auth/refresh',
            headers: { Authorization: `Bearer ${currentToken}` },
            withCredentials: true,
          })

          if (response.data?.access_token) {
            localStorage.setItem('accessToken', response.data.access_token)
            originalRequest.headers['Authorization'] = `Bearer ${response.data.access_token}`
            return $api.request(originalRequest)
          } else {
            throw new Error('Не получен новый токен')
          }
        } catch (e) {
          console.error('Ошибка обновления токена:', e)
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('isAuth')
          window.location.reload() //window.location.href = '/login'
          return Promise.reject(e)
        }
      }
      return Promise.reject(error)
    }
  )

  useMemo(async () => {
    if (isAuth) {
      let employee = (await $api.get(sanitizedConfig.REACT_APP_COMPANY_API_URL + '/v1/medics/me'))?.data
      employee.clientCompanies = (await getUserClientCompanies())?.data ?? []

      $api.interceptors.request.clear()

      $api.interceptors.request.use(
        async config => {
          const urlArray = config.url?.split('/')
          // TODO: change back to employee url.
          config.baseURL = sanitizedConfig.REACT_APP_COMPANY_API_URL
          // config.baseURL = employee.data.roles[0].product.ProductParametrs[0].api_url.slice(0, -2)
          if (config.url === '/v1/web/auth/refresh') return config
          const reversedUrlArray = urlArray?.reverse()
          if (reversedUrlArray) {
            if (
              (urlArray?.length === 5 && reversedUrlArray[0] === 'base64') ||
              (reversedUrlArray[0] === 'buffer' && config.method === 'get')
            ) {
              config.baseURL = sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL
            }

            if (urlArray?.reverse()[0] === 'files' && config.method === 'get') {
              config.responseType = 'blob'
            }
          }

          let currentAccessToken = localStorage.getItem('accessToken')
          if (!!currentAccessToken) {
            config.headers.Authorization = `Bearer ${currentAccessToken}`
          }
          return config
        },
        error => {
          console.log('Ошибка!')
          console.log(error)
        }
      )

      $file.interceptors.request.use(
        async config => {
          // TODO: change back to employee url.
          config.baseURL = sanitizedConfig.REACT_APP_COMPANY_API_URL
          // config.baseURL = employee.data.roles[0].product.ProductParametrs[0].api_url.slice(0, -2)
          config.responseType = 'blob'
          let currentAccessToken = localStorage.getItem('accessToken')
          if (!!currentAccessToken) {
            config.headers.Authorization = `Bearer ${currentAccessToken}`
          }
          return config
        },
        error => {}
      )

      dispatch(setOriginUrl(new URL(sanitizedConfig.REACT_APP_COMPANY_API_URL).origin))
      dispatch(setEmployeeUser(employee))
    } else {
      $api.interceptors.request.clear()
      $file.interceptors.request.clear()

      $api.interceptors.request.use(
        async config => {
          const BASE_URL = sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL

          const urlArray = config.url?.split('/')
          config.baseURL = BASE_URL
          if (config.url === '/v1/web/auth/refresh') return config
          const reversedUrlArray = urlArray?.reverse()
          if (reversedUrlArray) {
            if (
              (urlArray?.length === 5 && reversedUrlArray[0] === 'base64') ||
              (reversedUrlArray[0] === 'buffer' && config.method === 'get')
            ) {
              config.baseURL = sanitizedConfig.REACT_APP_ORGANISATIONS_API_URL
            }

            if (urlArray?.reverse()[0] === 'files' && config.method === 'get') {
              config.responseType = 'blob'
            }
          }

          let currentAccessToken = localStorage.getItem('accessToken')
          if (!!currentAccessToken) {
            config.headers.Authorization = `Bearer ${currentAccessToken}`
          }
          return config
        },
        error => {
          console.log('Ошибка!')
          console.log(error)
        }
      )
    }
  }, [isAuth])
}
